import { SidebarProvider } from '@/components/ui/sidebar';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { AppSidebar } from '@/components/AppSidebar';
import { SkipToContent } from '@/components/SkipToContent';
import { TopHeader } from '@/components/TopHeader';
import { ContextBar } from '@/components/ContextBar';
import { HeaderBreadcrumbs } from '@/components/HeaderBreadcrumbs';
import { AgentChat } from '@/agent/AgentChat';
import { HelpButton } from '@/components/help/HelpButton';
import { useChatPanel } from '@/stores/useChatPanel';
import { useSidebarState } from '@/stores/useSidebarState';
import { ProactiveEngine } from '@/agent/proactive/ProactiveEngine';

export function PlatformLayout({ children }: { children: React.ReactNode }) {
  const isOpen = useChatPanel((s) => s.isOpen);
  const size = useChatPanel((s) => s.size);
  const setOpen = useChatPanel((s) => s.setOpen);
  const sidebarExpanded = useSidebarState((s) => s.expanded);
  const setSidebarExpanded = useSidebarState((s) => s.setExpanded);

  return (
    <SidebarProvider open={sidebarExpanded} onOpenChange={setSidebarExpanded}>
      <ProactiveEngine />
      <SkipToContent />
      <div className="h-screen w-full flex overflow-hidden">
        <AppSidebar />
        <div className="flex-1 min-w-0 h-full overflow-hidden relative">
          {isOpen ? (
            <ResizablePanelGroup key={`open-${size}`} direction="horizontal" autoSaveId={`expai-layout-${size}`}>
              <ResizablePanel defaultSize={100 - size} minSize={40}>
                <div className="flex flex-col h-full min-h-0">
                  <TopHeader />
                  <HeaderBreadcrumbs />
                  <ContextBar />
                  <main id="main-content" tabIndex={-1} className="flex-1 min-h-0 overflow-auto p-4 md:p-6 focus:outline-none">
                    {children}
                  </main>
                </div>
              </ResizablePanel>
              <ResizableHandle className="w-1 bg-border hover:bg-primary/20 transition-colors" />
              <ResizablePanel defaultSize={size} minSize={18} collapsible>
                <div className="h-full min-h-0">
                  <AgentChat onClose={() => setOpen(false)} />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
          ) : (
            <div className="flex flex-col h-full min-h-0">
              <TopHeader />
              <HeaderBreadcrumbs />
              <ContextBar />
              <main id="main-content" tabIndex={-1} className="flex-1 min-h-0 overflow-auto p-4 md:p-6 focus:outline-none">
                {children}
              </main>
            </div>
          )}
        </div>
      </div>
      <HelpButton />
    </SidebarProvider>
  );
}
